export default __webpack_public_path__ + "static/raspberry-ripple-blank-2594199c2b8657610058d872106d4cc3.png";